@if (scheduledWith$ | async; as calendar) {
<div class="container">
  <mat-icon class="check-icon">check</mat-icon>
  @if (meetingRescheduled$ | async) {
  <h2 i18n="@@CONFIRMATION.RESCHEDULED">Meeting rescheduled</h2>
  } @else { @if (meetingCanceled$ | async) {
  <h2 i18n="@@CONFIRMATION.CANCELED">Meeting Canceled</h2>
  } @else {
  <h2 i18n="@@CONFIRMATION.CONFIRMED">Confirmed</h2>
  } } @if ((meetingCanceled$ | async) === false) {
  <p
    data-testid="bookme-confirmation-subtitle"
    class="subtitle"
    i18n="@@CONFIRMATION.YOU_ARE_SCHEDULED"
  >
    You are scheduled with {{ displayName$ | async }}
  </p>
  }
  <ul class="meeting-info">
    <li>
      <img
        class="profile-img"
        [src]="calendar.displayProfileUrl || './assets/images/profile.svg'"
        data-testid="bookme-confirmation-avatar"
      />
      <span data-testid="calendar-display-name" class="display-name">{{
        displayName$ | async
      }}</span>
    </li>
    <li>
      <mat-icon>watch_later</mat-icon>
      <span
        class="display-time"
        [ngClass]="{ 'meeting-time': (meetingRescheduled$ | async) }"
        data-testid="confirmation-meeting-time"
      >
        @if (timeSlot$ | async; as timeSlot) { @if (timezoneOffset$ | async; as
        timezoneOffset) {
        {{ timeSlot.start | date : 'h:mm a' : timezoneOffset }}
        - {{ timeSlot.end | date : 'h:mm a' : timezoneOffset }},
        {{ timeSlot.start | date : 'fullDate' : timezoneOffset }}<br />
        {{ timeSlot.timezone?.zone }} ({{ timeSlot.timezone?.region }}) } }
      </span>
    </li>
    @if (location$ | async; as location) {
    <li>
      <span class="in-person-location">
        <mat-icon>location_on</mat-icon>
        <span
          data-testid="meeting-location"
          [matTooltip]="location"
          matTooltipShowDelay="500"
          [class.truncated]="location.length > 50"
        >
          {{
            location.length > 50
              ? (location | slice : 0 : 50) + '...'
              : location
          }}
        </span>
      </span>
    </li>
    } @if ((meetingCanceled$ | async) === false) {
    <li>
      <mat-icon>email</mat-icon>
      <span class="details">
        You will receive the updated meeting invitation shortly.
      </span>
    </li>
    }
  </ul>
  <p class="footer">{{ message$ | async }}</p>
  @if (initialPath) {
  <a [routerLink]="[initialPath]" class="back-link">Back</a>
  }
</div>
}
